import { EventEmitter, Injectable } from "@angular/core";
import { ProgressEventWithId } from "./progress.model";

@Injectable({ providedIn: "root" })
export class ProgressNotificationService {
  static instance: ProgressNotificationService;

  constructor() {
    ProgressNotificationService.instance = this;
  }

  onProgress: EventEmitter<ProgressEventWithId> = new EventEmitter<ProgressEventWithId>();
  emitProgress(progressEvent: ProgressEventWithId): void {
    this.onProgress.emit(progressEvent);
  }
}
